import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import Cookies from 'js-cookie';
import { loginURL, meURL } from '../api/url';
import { handleFetch } from '../../../utils/handleFetch';

class AuthStore {
	user = null;
	errors = {
		email: null,
		password: null,
	};
	isLoading = true;

	constructor() {
		makeAutoObservable(this);
	}

	setIsLoading = (v) => (this.isLoading = v);

	login = async (body) => {
		runInAction(() => (this.errors = {}));
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: loginURL,
					method: 'POST',
					body,
					onSuccess: (data) => {
						runInAction(() => {
							this.errors = {};
							setTimeout(() => {
								this.user = data;
							}, 800);
						});
					},
					onValidationError: (errors) => runInAction(() => (this.errors = errors)),
				});
				if (!success) throw new Error('Failed to sign in');
				return success;
			})(),
			{
				loading: 'Signing in...',
				success: 'Signed in successfully!',
				error: 'Failed to sign in',
			},
		);
	};

	getMe = async () => {
		runInAction(() => (this.isLoading = true));
		return await handleFetch({
			url: meURL,
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.user = data)),
		});
	};

	logout = () => {
		Cookies.remove('token');
		window.location.reload();
	};

	get isUserLogin() {
		return this.user ? true : false;
	}

	get role() {
		return this.user?.role;
	}

	get permissions() {
		return this.user?.permissions || [];
	}
}

export const authStore = new AuthStore();
